<template>
  <div
    :class="[
      'vcheckbox_label',
      { disabled: disabled },
      { clickable: isLabelClickable },
      { custom_online: custom_online }
    ]"
  >
    <div class="checkbox-wrap checkbox_label_content" @click="change">
      <vfocus-field type="checkbox" :disabled="disabled">
        <vcheckbox v-tooltip="tooltip" :value="value" :disabled="disabled" />
      </vfocus-field>
    </div>

    <div class="checkbox_label" :class="{ 'checkbox_label--mini': mini }" @click="changeLabel" v-html="label"></div>
  </div>
</template>

<script>
import { isNumeric } from '@/_helpers/utils.js';
/*
@ complex component
@ props: value(any), label(string mask)
@ emit: input
*/
export default {
  name: 'VcheckboxLabel',
  props: {
    value: {
      type: Boolean,
      default: false,
      required: true
    },

    disabled: {
      type: Boolean,
      required: false
    },

    label: {
      type: [String, Number],
      default: ''
    },

    tooltip: {
      type: Object,
      default: null
    },

    custom_online: {
      type: Boolean,
      default: false
    },

    mini: {
      type: Boolean,
      default: false
    },

    isLabelClickable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    computedLabel() {
      if (isNumeric(this.label)) {
        return Intl.NumberFormat('ru-RU').format(this.label);
      }

      return this.label;
    }
  },

  methods: {
    change() {
      if (!this.disabled) {
        this.$emit('input', !this.value);
      }
    },

    changeLabel() {
      if (!this.disabled && this.isLabelClickable) {
        this.$emit('input', !this.value);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/fonts.scss';

.vcheckbox_label {
  display: flex;
  align-items: center;
  user-select: none;
  @include mixin-text-main;

  &.custom_online {
    align-items: flex-start;

    .checkbox_label {
      line-height: 22px;
    }
  }
  .checkbox_label {
    margin-left: 7px;
    word-break: normal;

    &--mini {
      margin-left: 10px;
    }
  }
}

.clickable {
  cursor: pointer;
}

.disabled {
  cursor: not-allowed;
}

.checkbox_label_content {
  display: flex;
  align-items: center;
}

.checkbox-wrap {
  display: flex;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
}
</style>
